import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";

import { CORE_URL, NEW_HOST_URL, NODE_ENV, PUBLISHER_URL, RELEASE_HASH } from "../../config/envConfig";
import { shouldSendLog } from "./errorFilters";

// Map environment names to shorter versions for Datadog
const getDatadogEnv = (env) => {
  const envMap = {
    production: "prod",
    staging: "stg",
    uat: "uat",
    development: "dev",
  };

  // Return mapped value or original if no mapping exists
  return envMap[env] || env;
};

export const initDataDog = () => {
  initDataDogRum();
  initDataDogLogs();
};

export const initDataDogRum = () => {
  datadogRum.init({
    applicationId: "3c7af622-8840-4902-9de0-c2821ced2d1c",
    clientToken: "pubff83b73c3e2c2f6d4d9a5ee5d4b0ab3a", // gitleaks:allow - Datadog public browser token
    site: "datadoghq.eu",
    service: "magnifi-dashboard",
    env: getDatadogEnv(NODE_ENV),
    version: RELEASE_HASH,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    actionNameAttribute: "data-testid",
    defaultPrivacyLevel: "mask-user-input",
    allowedTracingUrls: [NEW_HOST_URL, PUBLISHER_URL, CORE_URL],
    beforeSend: shouldSendLog("rum"),
  });
};

export const initDataDogLogs = () => {
  datadogLogs.init({
    clientToken: "pubee193c16ceb65c145dfc214b78fa893d", // gitleaks:allow - Datadog public browser token
    site: "datadoghq.eu",
    service: "magnifi-dashboard",
    env: getDatadogEnv(NODE_ENV),
    version: RELEASE_HASH,
    forwardConsoleLogs: "all",
    beforeSend: shouldSendLog("log"),
  });
};

export const setDataDogUserProperties = (userDetails) => {
  if (userDetails) {
    datadogLogs.setGlobalContextProperty("user", {
      userid: userDetails?._id,
      name: userDetails?.name,
      email: userDetails?.email,
    });

    datadogRum.setUser({
      id: userDetails?._id,
      name: userDetails?.name,
      email: userDetails?.email,
      otp_email: userDetails?.otp_email,
    });
  }
};

export const addRenderingErrorToDataDogRum = (error, info) => {
  const renderingError = new Error(error.message);
  renderingError.name = `ReactRenderingError`;
  renderingError.stack = info.componentStack;
  renderingError.cause = error;

  datadogRum.addError(renderingError);
};

export const stopDataDogSession = () => {
  datadogRum.stopSession();
};

export const getInternalDataDogContext = () => {
  return datadogRum.getInternalContext();
};
